// extracted by mini-css-extract-plugin
export var root = "_10654e081cc340b9307c8fd0d156fb1c-css";